import type { ReactNode } from 'react';
import Score from '@components/Score/Score';
import type { Mark } from '@/pages/CompanyReport/redux/interface';
import {
  DescriptionContainer,
  DescriptionHeading,
  DescriptionBlock,
  CopyBlock,
  ScoreLabel,
  HeadingNumber,
} from '../../styled';

type RenderProp = (score: number) => ReactNode;

interface Props {
  anchor: string;
  score: number;
  detailedScore: Mark[];
  heading: ReactNode;
  description: ReactNode;
  children?: RenderProp;
}
const Description = ({
  anchor,
  score,
  detailedScore,
  heading,
  description,
  children,
}: Props) => {
  const scoreValues = detailedScore.map((score) => ({ mark: score }));
  return (
    <DescriptionContainer>
      <DescriptionHeading>
        <HeadingNumber>{anchor}</HeadingNumber> {heading}
      </DescriptionHeading>
      <DescriptionBlock>{description}</DescriptionBlock>
      {children ? (
        children(score)
      ) : (
        <>
          <CopyBlock>
            Analysis Checks <ScoreLabel>{score.toString()}/6</ScoreLabel>
          </CopyBlock>
          <CopyBlock>
            <Score values={scoreValues} />
          </CopyBlock>
        </>
      )}
    </DescriptionContainer>
  );
};

export default Description;
